module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gb-Hb-Ic.2e4b2a2e.png";